import { useMemo } from 'react'

import styled from 'styled-components'

import { pink } from '../../../styles/colors'
import { formatLine } from '../admin_building_page/components/ManageSchedules/formatLine'

interface ReviewSequencePoint {
  point_id: string | number
  x: number | string
  y: number | string
}

interface ReviewSequencePathProps {
  sequence: Array<string | number>
  points: ReviewSequencePoint[]
  width?: number
}

export const ReviewSequencePath = ({
  sequence,
  points,
  width = 4,
}: ReviewSequencePathProps) => {
  const pointsById = useMemo(() => {
    const map = new Map<string, ReviewSequencePoint>()
    points.forEach(point => {
      map.set(String(point.point_id), point)
    })
    return map
  }, [points])

  const segments = useMemo(() => {
    const pairs: Array<{
      key: string
      top: number
      left: number
      height: number
      rotation: number
    }> = []

    for (let index = 0; index < sequence.length - 1; index++) {
      const startPoint = pointsById.get(String(sequence[index]))
      const endPoint = pointsById.get(String(sequence[index + 1]))
      const startX = parseFloat(String(startPoint?.x ?? ''))
      const startY = parseFloat(String(startPoint?.y ?? ''))
      const endX = parseFloat(String(endPoint?.x ?? ''))
      const endY = parseFloat(String(endPoint?.y ?? ''))
      if (
        !startPoint ||
        !endPoint ||
        !Number.isFinite(startX) ||
        !Number.isFinite(startY) ||
        !Number.isFinite(endX) ||
        !Number.isFinite(endY)
      ) {
        continue
      }
      const lineData = formatLine(startX, startY, endX, endY)
      pairs.push({
        key: `${sequence[index]}-${sequence[index + 1]}-${index}`,
        ...lineData,
      })
    }
    return pairs
  }, [pointsById, sequence])

  if (sequence.length < 2) {
    return null
  }

  return (
    <>
      {segments.map(segment => (
        <PathSegment
          key={segment.key}
          $width={width}
          style={{
            top: segment.top,
            left: segment.left,
            height: segment.height,
            transform: `rotate(${segment.rotation}deg)`,
          }}
        />
      ))}
    </>
  )
}

const PathSegment = styled.div<{ $width: number }>`
  pointer-events: none;
  position: absolute;
  box-sizing: content-box;
  background-color: ${pink};
  width: ${props => props.$width}px;
  margin-left: ${props => -props.$width / 2}px;
  z-index: 1;
  opacity: 0.85;
`
